export const rewriteLegacyHashRouterUrl = () => {
  const { hash, pathname, search } = window.location;

  if (!hash.startsWith('#/')) {
    return;
  }

  const legacyRoute = hash.substring(1);
  const anchorIndex = legacyRoute.indexOf('/#');
  const nextPath = anchorIndex >= 0 ? legacyRoute.substring(0, anchorIndex) : legacyRoute;
  const nextHash = anchorIndex >= 0 ? legacyRoute.substring(anchorIndex + 1) : '';

  window.history.replaceState({}, '', `${pathname.replace(/\/$/, '')}${nextPath}${search}${nextHash}`);
};
